import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';

// eslint-disable-next-line import/no-named-as-default-member
export default i18n
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    supportedLngs: ['en'],
    fallbackLng: 'en',
    defaultNS: 'en',
    fallbackNS: 'en',
    preload: ['en'],
    detection: {
      order: ['localStorage', 'htmlTag'],
    },
    backend: {
      loadPath: '/locales/en/common.json',
    },
    react: { useSuspense: false },
    interpolation: {
      escapeValue: false,
    },
  });
